import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux"

import { setColorDimensions, setInsideColorDimensions, setPublishLevel } from "../../store/dimensions/dimensionsSlice";

import { getDimensionDescription } from "../../helpers/getDimensionDescription";

import DimensionSelect from "./DimensionSelect/DimensionSelect";

import {_ConfiguratorSection as ConfiguratorSection} from "./Configurator.styles";
class Configurator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValues: this.props.selectedValues,
      renderMode: "default",
      visibleColorPicker: false,
    };

    this.getSelectedValueForDimension = this.getSelectedValueForDimension.bind(this);
    this.newValueSelected = this.newValueSelected.bind(this);
    this.showColorPicker = this.showColorPicker.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        selectedValues: nextProps.selectedValues,
      });
    }
  }

  componentDidMount() {
    const dimensions = this.props.dimensions;
    dimensions.some(dimension => (
      dimension.dimensionGroupCode === "DOR" || dimension.dimensionGroupCode === "WDW") &&
        this.setState({renderMode: "design"}
    ));

    this.props.setColorDimensions(
      this.props.dimensions.filter(dimension => (
        dimension.dimensionCode === "dorColor" || dimension.dimensionCode === "wdwColor"
      ))
    );
    
    this.props.setInsideColorDimensions(
      this.props.dimensions.filter(dimension => (
        dimension.dimensionCode === "dorInsideColor" || dimension.dimensionCode === "wdwInsideColor"
        ))
    );

    const publishLevel = this.props.publishLevel;
    if (publishLevel) {
      this.props.setPublishLevel(publishLevel);
    }
  }
  
  getSelectedValueForDimension(dimension) {
    return this.props.selectedValues.find(selectedValue =>
      dimension.values.find(value => value.valueId === selectedValue)
    );
  }

  showColorPicker(optional) {
    this.setState({visibleColorPicker: optional});
  }
  
  hiddenDimension(dimension) {
    return this.props.dimsHiddenFromMarkets && this.props.dimsHiddenFromMarkets.some(element => dimension === element.hiddenDimId);
  }

  newValueSelected(newValueId, prevValueId) {
    const handingDimension = this.props.dimensions.filter(dimension => dimension.dimensionCode === "dorHanding");

    if (handingDimension.length && newValueId !== prevValueId) {
      const handingDimensionValues = handingDimension[0].values;
      const valueMatchesHandingDimension = handingDimensionValues.filter(option => option.valueId === newValueId);
      
      if (valueMatchesHandingDimension.length) {
        this.props.handleHandingChange();
      }
    }

    
    this.setState(
      prevState => {
        prevState.selectedValues.push(newValueId);

        if (prevValueId) {
          prevState.selectedValues.splice(
            prevState.selectedValues.indexOf(prevValueId),
            1
          );
        }
        return {
          selectedValues: prevState.selectedValues
        };
      },
      () => {
        this.props.onChange(this.state.selectedValues);
      }
    );
  }

  render() {
    const imageThumbnailDimensions = this.props.dimensions.filter(dimension => (
      dimension.dimensionCode === "dorHandle" ||
      dimension.dimensionCode === "dorHanding" ||
      dimension.dimensionCode === "wdwSPROSS" ||
      dimension.dimensionCode === "wdwSPROSSDUPLEX" || 
      dimension.dimensionCode === "wdwSPROSSENERGY" || 
      dimension.dimensionCode === "wdwMITTPOST"      
    ));

    const dropdownDimensions = this.props.dimensions.filter(dimension => (
      dimension.dimensionCode !== "dorColor" 
        && dimension.dimensionCode !== "dorInsideColor"
        && dimension.dimensionCode !== "dorHandle"
        && dimension.dimensionCode !== "dorHanding"
        && dimension.dimensionCode !== "wdwColor" 
        && dimension.dimensionCode !== "wdwInsideColor"
        && dimension.dimensionCode !== "wdwSPROSS"
        && dimension.dimensionCode !== "wdwSPROSSDUPLEX"
        && dimension.dimensionCode !== "wdwSPROSSENERGY"
    ));
    
    const allColorDimensions = this.props.colorDimensions.concat(this.props.insideColorDimensions)
    return (
      <div className="lfc-configurator">
        {
          // Render lfc-door
          (this.state.renderMode === "design") && <>
            
             {/* Render dropdown dimensions */}
            <ConfiguratorSection>
              {
                dropdownDimensions.map(dimension => {
                  const { dimensionId, dimensionType, values } = dimension;

                  if (this.hiddenDimension(dimension.dimensionId)) return null;

                  return (
                    <DimensionSelect
                      key={"d".concat(dimensionId.toString())}
                      id={"d".concat(dimensionId.toString())}
                      type={dimensionType}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={this.props.renderDimensionDescriptions && getDimensionDescription(
                        dimension,
                        this.props.language
                      )}
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        info => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                    />
                  )
                })
              }
            </ConfiguratorSection>
            
            {/* Render color dimension, to be displayed as color boxes/thumbnails */}
            <ConfiguratorSection className="colors">
              { 
                allColorDimensions.map(dimension => {
                  const { dimensionId, dimensionCode, values } = dimension;

                  if (this.hiddenDimension(dimension.dimensionId)) return null;

                  return (
                    <DimensionSelect
                      key={"d".concat(dimensionId.toString())}
                      id={"d".concat(dimensionId.toString())}
                      dimensionCode={dimensionCode.toString()}
                      type={"THUMBNAIL"}
                      variant={"COLOR"}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={this.props.renderDimensionDescriptions && getDimensionDescription(
                        dimension,
                        this.props.language
                      )}
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        info => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                      showColorPicker={this.showColorPicker}
                    />
                  )
                })
              }
            </ConfiguratorSection>
            
            {/* Render dimensions related that should be displayed as image thumbnails */}
            <ConfiguratorSection className="thumnail">
              {
                imageThumbnailDimensions.map(dimension => {
                  const { dimensionId, dimensionCode, values } = dimension;

                  if (this.hiddenDimension(dimension.dimensionId)) return null;
                  
                  return (
                    <DimensionSelect
                      key={"d".concat(dimensionId.toString())}
                      id={"d".concat(dimensionId.toString())}
                      dimensionCode={dimensionCode.toString()}
                      type={"THUMBNAIL"}
                      variant={"IMAGE"}
                      name={dimension[`dimensionName${this.props.language}`]}
                      description={this.props.renderDimensionDescriptions && getDimensionDescription(
                        dimension,
                        this.props.language
                      )}
                      language={this.props.language}
                      messages={this.props.messages}
                      values={values}
                      getDimensionName={this.props.getDimensionName}
                      getValueCode={this.props.getValueCode}
                      getValueName={this.props.getValueName}
                      selectedValue={this.getSelectedValueForDimension(dimension)}
                      correctionInformation={this.props.correctionInformation.find(
                        info => info.dimensionId === dimensionId
                      )}
                      onChange={this.newValueSelected}
                    />
                  )
                })
              }
            </ConfiguratorSection>
          </>
        }

        {
          // Default rendering method for other lfc products
          this.state.renderMode === "default" && this.props.dimensions.map(dimension => {
            if (!this.hiddenDimension(dimension.dimensionId)) {
              return (
                <DimensionSelect
                  key={"d".concat(dimension.dimensionId.toString())}
                  id={"d".concat(dimension.dimensionId.toString())}
                  type={dimension.dimensionType}
                  name={dimension[`dimensionName${this.props.language}`]}
                  description={this.props.renderDimensionDescriptions && getDimensionDescription(
                    dimension,
                    this.props.language
                  )}
                  language={this.props.language}
                  messages={this.props.messages}
                  values={dimension.values}
                  getDimensionName={this.props.getDimensionName}
                  getValueCode={this.props.getValueCode}
                  getValueName={this.props.getValueName}
                  selectedValue={this.getSelectedValueForDimension(dimension)}
                  correctionInformation={this.props.correctionInformation.find(
                    info => info.dimensionId === dimension.dimensionId
                  )}
                  onChange={this.newValueSelected}
                />
              )
            } else return null;
          }) 
        }
      </div>
    );
  }
}

Configurator.propTypes = {
  correctionInformation: PropTypes.arrayOf(PropTypes.shape({
    dimensionId: PropTypes.number,
    constraint: PropTypes.object,
  })),
  defaultValues: PropTypes.arrayOf(PropTypes.shape({
    defaultDimensionSortOrder: PropTypes.number,
    dimensionCode: PropTypes.string,
    dimensionGroupCode: PropTypes.string,
    dimensionId: PropTypes.number,
    dimensionNameEN: PropTypes.string,
    dimensionNameFI: PropTypes.string,
    dimensionNameNO: PropTypes.string,
    dimensionNameSE: PropTypes.string,
    dimensionType: PropTypes.string,
    dimensionUIHint: PropTypes.string,
    hintDescriptionEN: PropTypes.string,
    hintDescriptionFI: PropTypes.string,
    hintDescriptionNO: PropTypes.string,
    hintDescriptionSE: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.number),
  })),
  language: PropTypes.oneOf(["SE", "NO", "FI", "EN"]).isRequired,
  messages: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func,
  env: PropTypes.string,
  lfcMode: PropTypes.string,
  priceHelper: PropTypes.func,
  pricingInfo: PropTypes.string,
  renderDimensionDescriptions: PropTypes.bool,
  updateInProgress: PropTypes.func,
  handleHandingChange: PropTypes.func,
  publishLevel: PropTypes.number,
}

const mapStateToProps = (state) => ({
  colorDimensions: state.dimensions.colorDimensions,
  insideColorDimensions: state.dimensions.insideColorDimensions,
})

const mapDispatchToProps = {
  setColorDimensions,
  setInsideColorDimensions,
  setPublishLevel,
};

export default connect(mapStateToProps, mapDispatchToProps)(Configurator);
